export default __webpack_public_path__ + "static/media/G0750.34I-27930_-16781_0.1666264680000.422687f8.jpg";